import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const storedDpiLocaleModule: LocaleModule = {
  name: "storedDpi",
  messages: { en: en, it: it },
};
